import SvgInteractive from './Loader';

export default SvgInteractive;
